{
  "list": {
    "title": "Filtros",
    "create": "Crear filtro",
    "import": "Importar filtro",
    "loadError": "Ocurrió un error al cargar los filtros.",
    "statusAll": "Todos",
    "statusEnabled": "Habilitados",
    "statusDisabled": "Deshabilitados",
    "noStatusFilters": "No hay filtros {{status}}",
    "noFilters": "No hay filtros aquí..",
    "addNew": "Agregar nuevo",
    "copied": "¡Filtro copiado al portapapeles!",
    "copyFailed": "Error al copiar JSON al portapapeles.",
    "fetchFailed": "Error al obtener datos del filtro.",
    "deleted": "El filtro {{name}} fue eliminado",
    "duplicated": "Filtro {{name}} duplicado",
    "updated": "{{name}} fue actualizado exitosamente",
    "removeTitle": "Eliminar filtro: {{name}}",
    "removeText": "¿Estás seguro de que quieres eliminar este filtro? Esta acción no se puede deshacer.",
    "edit": "Editar",
    "exportJson": "Exportar JSON",
    "exportJsonDiscord": "Exportar JSON a Discord",
    "toggle": "Alternar",
    "duplicate": "Duplicar",
    "delete": "Eliminar",
    "toggleSuccess": "{{name}} fue {{state}} exitosamente",
    "enabledState": "habilitado",
    "disabledState": "deshabilitado",
    "autoUpdatedTitle": "Este filtro se actualiza automáticamente por una lista",
    "priority": "Prioridad",
    "actions": "Acciones",
    "noActionsDefined": "No hay acciones definidas. Configura acciones para habilitar la descarga.",
    "noActionsEnabled": "Necesitas habilitar al menos una acción en el filtro, de lo contrario no obtendrás ninguna descarga.",
    "downloads": "Descargas",
    "per": "por",
    "usesDisabledIndexers": "Usa indexador(es) deshabilitado(s): {{names}}",
    "noIndexer": "SIN INDEXADOR",
    "sort": {
      "label": "Ordenar",
      "default": "Más reciente",
      "nameAsc": "Nombre A-Z",
      "nameDesc": "Nombre Z-A",
      "priorityDesc": "Prioridad Alta-Baja",
      "priorityAsc": "Prioridad Baja-Alta",
      "createdDesc": "Creados recientemente primero",
      "createdAsc": "Creados recientemente último",
      "updatedDesc": "Actualizados recientemente primero",
      "updatedAsc": "Actualizados recientemente último"
    },
    "indexerFilter": {
      "label": "Indexador",
      "all": "Todos los indexadores"
    }
  },
  "details": {
    "tabs": {
      "general": "General",
      "moviesTv": "Películas y TV",
      "music": "Música",
      "advanced": "Avanzado",
      "external": "Externo",
      "actions": "Acciones",
      "notifications": "Notificaciones",
      "new": "NUEVO"
    },
    "removeTitle": "Eliminar filtro: {{name}}",
    "removeText": "¿Estás seguro de que quieres eliminar este filtro? Esta acción no se puede deshacer.",
    "delete": "Eliminar filtro",
    "reset": "Restablecer valores del formulario",
    "resetSuccess": "Se restablecieron todos los valores del filtro.",
    "save": "Guardar",
    "validationError": "Error de validación",
    "validationErrors": "Errores de validación",
    "mustSelectClient": "Debes seleccionar un cliente"
  },
  "importer": {
    "title": "Importar filtro (en formato JSON o autodl-irssi)",
    "import": "Importar",
    "cancel": "Cancelar",
    "jsonImported": "¡Filtro '{{name}}' importado exitosamente!",
    "jsonImportFailed": "Error al importar datos JSON. Información registrada en la consola.",
    "invalidFormat": "No se puede importar el filtro dado -- no está en formato JSON ni autodl-irssi.",
    "autodlImportFailed": "Error al importar filtro autodl-irssi '{{name}}'. Información registrada en la consola.",
    "autodlImportedOne": "¡Filtro '{{name}}' importado exitosamente!",
    "autodlImportedMany": "¡Los {{count}} filtros fueron importados exitosamente!",
    "autodlImportedPartial": "{{success}}/{{total}} filtros importados exitosamente. Ver consola para detalles.",
    "placeholder": "Pega los datos de tu filtro aquí (en formato JSON de autobrr o tu configuración completa de autodl-irssi)",
    "warnings": "Advertencias de importación"
  },
  "general": {
    "filterName": "Nombre del filtro",
    "filterNamePlaceholder": "ej. Filtro 1",
    "announceTypes": "tipos de anuncio",
    "announceTypesTooltip": "¡NUEVO! Coincidir con lanzamientos que contengan cualquiera de los tipos de anuncio seleccionados.",
    "indexers": "Indexadores",
    "rulesTitle": "Reglas",
    "rulesSubtitle": "Especifica reglas sobre cómo se deben manejar/seleccionar los torrents.",
    "minSize": "Tamaño mínimo",
    "maxSize": "Tamaño máximo",
    "sizePlaceholder": "ej. 100MiB, 80GB",
    "sizeTooltip": "Soporta unidades como MB, MiB, GB, etc.",
    "delay": "Retraso",
    "delayPlaceholder": "Número de segundos para retrasar las acciones",
    "delayTooltip": "Número de segundos a esperar antes de ejecutar las acciones.",
    "priority": "Prioridad",
    "priorityPlaceholder": "Mayor número = mayor prioridad",
    "priorityTooltip": "Los filtros se verifican en orden de prioridad. Mayor número = mayor prioridad.",
    "maxDownloads": "Descargas máximas",
    "maxDownloadsPlaceholder": "Acepta cualquier número (0 es infinito)",
    "maxDownloadsTooltip": "Número máximo de descargas según la unidad respectiva.",
    "maxDownloadsPer": "Descargas máximas por",
    "selectUnit": "Seleccionar unidad",
    "maxDownloadsPerTooltip": "La unidad de tiempo para contar las descargas máximas por filtro.",
    "skipDuplicatesProfile": "Perfil de omisión de duplicados",
    "selectProfile": "Seleccionar perfil",
    "skipDuplicatesProfileTooltip": "Seleccionar el perfil de omisión de duplicados.",
    "enabled": "Habilitado",
    "enabledDescription": "Habilitar o deshabilitar este filtro."
  },
  "actionsSection": {
    "title": "Acciones",
    "subtitle": "Agregar a clientes de descarga o ejecutar comandos personalizados.",
    "addNew": "Agregar nueva",
    "empty": "¡Aún no hay acciones!",
    "deleted": "La acción {{name}} fue eliminada",
    "removeTitle": "Eliminar acción del filtro",
    "removeText": "¿Estás seguro de que quieres eliminar esta acción? Esta acción no se puede deshacer.",
    "actionTitle": "Acción",
    "actionSubtitle": "Define el cliente de descarga para tu acción y su nombre",
    "actionType": "Tipo de acción",
    "selectType": "Seleccionar tipo",
    "actionTypeTooltip": "Selecciona el tipo de acción para esta acción.",
    "name": "Nombre",
    "removeAction": "Eliminar acción",
    "close": "Cerrar"
  },
  "notificationsSection": {
    "title": "Notificaciones del filtro",
    "subtitle": "Configura qué notificaciones deben enviarse para este filtro. Estas anulan la configuración global de notificaciones.",
    "addNotification": "Agregar notificación",
    "empty": "No hay notificaciones específicas del filtro configuradas. Se usarán las notificaciones globales.",
    "selectNotification": "Seleccionar notificación",
    "muted": "Silenciado",
    "eventsCount_one": "{{count}} evento",
    "eventsCount_other": "{{count}} eventos",
    "removeTitle": "Eliminar notificación",
    "removeText": "¿Estás seguro de que quieres eliminar esta notificación? Esta acción no se puede deshacer.",
    "notificationTitle": "Notificación",
    "notificationSubtitle": "Selecciona el servicio de notificación y los eventos a activar",
    "notificationService": "Servicio de notificación",
    "selectNotificationService": "Seleccionar una notificación",
    "notificationServiceTooltip": "Selecciona el servicio de notificación a usar para este filtro.",
    "notificationSettings": "Configuración de notificaciones",
    "muteFilter": "Silenciar filtro",
    "muteFilterDesc": "Deshabilitar todas las notificaciones para este filtro. Cuando está silenciado, no se enviarán notificaciones para los lanzamientos coincidentes con este filtro.",
    "mutedInfo": "Filtro silenciado - anula toda la configuración global de notificaciones",
    "triggerEvents": "Eventos de activación",
    "pushApproved": "Envío aprobado",
    "pushRejected": "Envío rechazado",
    "pushError": "Error de envío",
    "pushApprovedDesc": "Enviar notificación cuando el lanzamiento se envía exitosamente al cliente",
    "pushRejectedDesc": "Enviar notificación cuando el lanzamiento es rechazado",
    "pushErrorDesc": "Enviar notificación cuando ocurre un error durante el procesamiento",
    "removeNotification": "Eliminar notificación",
    "close": "Cerrar"
  },
  "advanced": {
    "common": {
      "useRegex": "Usar Regex",
      "regexTooltip1": "Este campo tiene soporte completo de regex (variante Golang).",
      "regexTooltip2": "Recuerda marcar Usar Regex si usas más que * y ?.",
      "regexTooltip3": "Modo: (?i) insensible a mayúsculas"
    },
    "releases": {
      "title": "Nombres de lanzamiento",
      "subtitle": "Coincidir solo con ciertos nombres de lanzamiento y/o ignorar otros nombres de lanzamiento.",
      "match": "Coincidir lanzamientos",
      "matchPlaceholder": "ej. *alguna?pelicula*,*alguna?serie*s01*",
      "except": "Excepto lanzamientos",
      "exceptPlaceholder": "ej. *mala?pelicula*,*mala?serie*s03*",
      "alert": "Pregúntate:",
      "matchWarning": "¿Tienes una buena razón para usar Coincidir lanzamientos en lugar de una de las otras pestañas?",
      "exceptWarning": "¿Tienes una buena razón para usar Excepto lanzamientos en lugar de una de las otras pestañas?"
    },
    "groups": {
      "title": "Grupos",
      "subtitle": "Coincidir solo con ciertos grupos y/o ignorar otros grupos.",
      "match": "Coincidir grupos de lanzamiento",
      "matchPlaceholder": "ej. grupo1,grupo2",
      "matchTooltip": "Lista separada por comas de grupos de lanzamiento a coincidir.",
      "except": "Excepto grupos de lanzamiento",
      "exceptPlaceholder": "ej. malgrupo1,malgrupo2",
      "exceptTooltip": "Lista separada por comas de grupos de lanzamiento a ignorar (tiene prioridad sobre Coincidir lanzamientos)."
    },
    "categories": {
      "title": "Categorías",
      "subtitle": "Coincidir o excluir categorías (si se anuncian)",
      "match": "Coincidir categorías",
      "matchPlaceholder": "ej. *categoría*,categoría1",
      "matchTooltip": "Lista separada por comas de categorías a coincidir.",
      "except": "Excepto categorías",
      "exceptPlaceholder": "ej. *categoría*",
      "exceptTooltip": "Lista separada por comas de categorías a ignorar (tiene prioridad sobre Coincidir lanzamientos)."
    },
    "tags": {
      "title": "Etiquetas",
      "subtitle": "Coincidir o excluir etiquetas (si se anuncian)",
      "match": "Coincidir etiquetas",
      "matchPlaceholder": "ej. etiqueta1,etiqueta2",
      "matchTooltip": "Lista separada por comas de etiquetas a coincidir.",
      "matchLogic": "Lógica de coincidencia",
      "matchLogicDefault": "cualquiera",
      "matchLogicTooltip": "Lógica usada para coincidir etiquetas del filtro.",
      "except": "Excepto etiquetas",
      "exceptPlaceholder": "ej. etiqueta1,etiqueta2",
      "exceptTooltip": "Lista separada por comas de etiquetas a ignorar (tiene prioridad sobre Coincidir lanzamientos).",
      "exceptLogic": "Lógica de excepción",
      "exceptLogicDefault": "cualquiera",
      "exceptLogicTooltip": "Lógica usada para coincidir etiquetas de excepción."
    },
    "uploaders": {
      "title": "Subidores",
      "subtitle": "Coincidir o ignorar subidores (si se anuncian)",
      "match": "Coincidir subidores",
      "matchPlaceholder": "ej. subidor1,subidor2",
      "matchTooltip": "Lista separada por comas de subidores a coincidir.",
      "except": "Excepto subidores",
      "exceptPlaceholder": "ej. anonimo1,anonimo2",
      "exceptTooltip": "Lista separada por comas de subidores a ignorar (tiene prioridad sobre Coincidir lanzamientos)."
    },
    "language": {
      "title": "Idioma",
      "subtitle": "Coincidir o ignorar idiomas (si se anuncian)",
      "match": "Coincidir idioma",
      "except": "Excepto idioma"
    },
    "origins": {
      "title": "Orígenes",
      "subtitle": "Coincidir Internals, Scene, P2P, etc. (si se anuncian)",
      "match": "Coincidir orígenes",
      "except": "Excepto orígenes"
    },
    "freeleech": {
      "title": "Freeleech",
      "subtitle": "Coincidir basado en freeleech (si se anuncia)",
      "percent": "Porcentaje de freeleech",
      "percentPlaceholder": "ej. 50,75-100",
      "percentTooltip1": "El freeleech puede anunciarse como un valor binario verdadero/falso o como porcentaje, dependiendo del indexador. Usa uno u otro.",
      "percentTooltip2": "El interruptor de Freeleech anula este campo si está activado/verdadero.",
      "percentTooltip3": "Consulta nuestra documentación para más detalles:",
      "toggle": "Freeleech",
      "toggleDescription": "No se puede usar con Porcentaje de freeleech. Anula Porcentaje de freeleech si está activado/verdadero.",
      "toggleTooltip1": "El freeleech puede anunciarse como un valor binario verdadero/falso o como porcentaje, dependiendo del indexador. Usa uno u otro.",
      "toggleTooltip2": "Este campo anula Porcentaje de freeleech si está activado/verdadero.",
      "toggleTooltip3": "Consulta quién usa qué en la documentación:"
    },
    "feedSpecific": {
      "title": "Específico de RSS/Torznab/Newznab",
      "subtitle": "Estas opciones son solo para feeds como RSS, Torznab y Newznab",
      "matchDescription": "Coincidir descripción",
      "matchDescriptionPlaceholder": "ej. *alguna?pelicula*,*alguna?serie*s01*",
      "exceptDescription": "Excepto descripción",
      "exceptDescriptionPlaceholder": "ej. *mala?pelicula*,*mala?serie*s03*",
      "minSeeders": "Mín. seeders",
      "maxSeeders": "Máx. seeders",
      "minLeechers": "Mín. leechers",
      "maxLeechers": "Máx. leechers",
      "countPlaceholder": "Acepta cualquier número (0 es infinito)",
      "seedersTooltip": "Número de {{type}} según la unidad respectiva. Solo para Torznab"
    },
    "rawReleaseTags": {
      "title": "Etiquetas de lanzamiento sin procesar",
      "subtitlePrefix": "Solo usuarios avanzados",
      "subtitleSuffix": "Esta es la cadena de releaseTags sin procesar del anuncio.",
      "warning": "Estas podrían no ser lo que piensas. Para usuarios muy avanzados que saben cómo se parsean las cosas.",
      "match": "Coincidir etiquetas de lanzamiento",
      "except": "Excepto etiquetas de lanzamiento",
      "placeholder": "ej. *mkv*,*foreign*"
    }
  },
  "moviesTv": {
    "title": "Películas / Series",
    "placeholder": "ej. Película,Serie 1,Serie?2",
    "wildcardTooltip": "Puedes usar filtrado básico como comodines * o reemplazar caracteres individuales con ?",
    "years": "Años",
    "yearsPlaceholder": "ej. 2018,2019-2021",
    "yearsTooltip": "Este campo acepta un rango de años y/o años individuales separados por comas.",
    "seasonEpisode": {
      "title": "Temporadas, episodios y fecha",
      "subtitle": "Establecer restricciones de coincidencia de temporada, episodio, año, meses y día.",
      "seasons": "Temporadas",
      "seasonsPlaceholder": "ej. 1,3,2-6",
      "seasonsTooltip": "Consulta la documentación para información sobre cómo obtener solo packs de temporada:",
      "episodes": "Episodios",
      "episodesPlaceholder": "ej. 2,4,10-20",
      "episodesTooltip": "Consulta la documentación para información sobre cómo obtener solo episodios:",
      "dailyShows": "Series diarias",
      "months": "Meses",
      "monthsPlaceholder": "ej. 4,2-9",
      "monthsTooltip": "Este campo acepta un rango de años y/o meses individuales separados por comas.",
      "days": "Días",
      "daysPlaceholder": "ej. 1,15-30",
      "daysTooltip": "Este campo acepta un rango de años y/o días individuales separados por comas.",
      "smartEpisode": "Episodio inteligente",
      "smartEpisodeDescription": "No coincidir con episodios más antiguos que el último coincidente."
    },
    "quality": {
      "title": "Calidad",
      "subtitle": "Establecer restricciones de coincidencia de resolución, fuente, códec y relacionados.",
      "resolutions": "Resoluciones",
      "resolutionsTooltip": "Coincidirá con lanzamientos que contengan cualquiera de las resoluciones seleccionadas.",
      "sources": "Fuentes",
      "sourcesTooltip": "Coincidirá con lanzamientos que contengan cualquiera de las fuentes seleccionadas.",
      "codecs": "Códecs",
      "codecsTooltip": "Coincidirá con lanzamientos que contengan cualquiera de los códecs seleccionados.",
      "containers": "Contenedores",
      "containersTooltip": "Coincidirá con lanzamientos que contengan cualquiera de los contenedores seleccionados.",
      "matchHdr": "Coincidir HDR",
      "matchHdrTooltip": "Coincidirá con lanzamientos que contengan cualquiera de las designaciones HDR seleccionadas.",
      "exceptHdr": "Excepto HDR",
      "exceptHdrTooltip": "No coincidirá con lanzamientos que contengan cualquiera de las designaciones HDR seleccionadas (tiene prioridad sobre Coincidir HDR).",
      "matchOther": "Coincidir otros",
      "matchOtherTooltip": "Coincidirá con lanzamientos que contengan cualquiera de las designaciones seleccionadas.",
      "exceptOther": "Excepto otros",
      "exceptOtherTooltip": "No coincidirá con lanzamientos que contengan cualquiera de las designaciones Otros seleccionadas (tiene prioridad sobre Coincidir Otros)."
    }
  },
  "music": {
    "artists": "Artistas",
    "artistsPlaceholder": "ej. Artista Uno",
    "albums": "Álbumes",
    "albumsPlaceholder": "ej. Ese Álbum",
    "wildcardTooltip": "Puedes usar filtrado básico como comodines * o reemplazar caracteres individuales con ?",
    "matchRecordLabels": "Coincidir sellos discográficos",
    "matchRecordLabelsPlaceholder": "ej. Anjunabeats, Armada",
    "matchRecordLabelsTooltip": "Lista separada por comas de sellos discográficos a coincidir. Solo Orpheus y Redacted soportan esto.",
    "exceptRecordLabels": "Excepto sellos discográficos",
    "exceptRecordLabelsPlaceholder": "ej. Anjunadeep, Armind",
    "exceptRecordLabelsTooltip": "Lista separada por comas de sellos discográficos a ignorar (tiene prioridad sobre Coincidir sellos discográficos). Solo Orpheus y Redacted soportan esto.",
    "releaseDetails": {
      "title": "Detalles del lanzamiento",
      "subtitle": "Tipo (Álbum, Single, EP, etc.) y año del lanzamiento (si se anuncia)",
      "musicType": "Tipo de música",
      "musicTypeTooltip": "Solo coincidirá con lanzamientos de cualquiera de los tipos seleccionados.",
      "years": "Años",
      "yearsPlaceholder": "ej. 2018,2019-2021",
      "yearsTooltip": "Este campo acepta un rango de años y/o años individuales separados por comas."
    },
    "quality": {
      "title": "Calidad",
      "subtitle": "Formato, fuente, log, etc.",
      "format": "Formato",
      "formatTooltip": "Solo coincidirá con lanzamientos de cualquiera de los formatos seleccionados. Esto es anulado por FLAC Perfecto.",
      "quality": "Calidad",
      "qualityTooltip": "Solo coincidirá con lanzamientos de cualquiera de las calidades seleccionadas. Esto es anulado por FLAC Perfecto.",
      "media": "Medio",
      "mediaTooltip": "Solo coincidirá con lanzamientos de cualquiera de las fuentes seleccionadas. Esto es anulado por FLAC Perfecto.",
      "cue": "Cue",
      "cueDescription": "Debe incluir información CUE",
      "log": "Log",
      "logDescription": "Debe incluir información LOG",
      "logScore": "Puntuación de log",
      "logScorePlaceholder": "ej. 100",
      "logScoreTooltip": "Las puntuaciones de log van de 0 a 100. Esto es anulado por FLAC Perfecto.",
      "or": "O",
      "perfectFlac": "FLAC Perfecto",
      "perfectFlacDescription": "Anular todas las opciones sobre calidad, fuente, formato, y cue/log/puntuación de log.",
      "perfectFlacTooltip": "Anular todas las opciones sobre calidad, fuente, formato, y CUE/LOG/puntuación de LOG.",
      "perfectFlacHint": "Esto es lo que quieres en el 90% de los casos (en lugar de las opciones anteriores)."
    }
  },
  "external": {
    "title": "Filtros externos",
    "subtitle": "Ejecutar scripts externos o webhooks y verificar el estado como parte del filtrado.",
    "addNew": "Agregar nuevo",
    "empty": "¡Aún no hay filtros externos!",
    "removeTitle": "Eliminar filtro externo",
    "removeText": "¿Estás seguro de que quieres eliminar este filtro externo? Esta acción no se puede deshacer.",
    "sectionTitle": "Filtro externo",
    "sectionSubtitle": "Define el tipo de tu filtro y su nombre",
    "type": "Tipo",
    "name": "Nombre",
    "onError": "En error",
    "selectType": "Seleccionar tipo",
    "typeTooltip": "Selecciona el tipo para este filtro externo.",
    "onErrorTooltip": "Selecciona qué hacer en caso de error para este filtro externo.",
    "remove": "Eliminar externo",
    "close": "Cerrar",
    "types": {
      "EXEC": "Exec",
      "WEBHOOK": "Webhook"
    },
    "onErrorOptions": {
      "REJECT": "Rechazar",
      "CONTINUE": "Continuar al siguiente"
    },
    "execute": {
      "title": "Ejecutar",
      "subtitle": "Especifica el ejecutable, el argumento y el estado de salida esperado para ejecutar como pre-filtro",
      "path": "Ruta al ejecutable",
      "pathPlaceholder": "Ruta absoluta al ejecutable ej. /bin/test",
      "pathTooltip": "Para comandos personalizados debes especificar la ruta completa al binario/programa que quieres ejecutar. Y puedes incluir tus propias variables estáticas:",
      "args": "Argumentos de ejecución",
      "argsPlaceholder": "Argumentos ej. --test \"{{ .TorrentName }}\"",
      "expectedExitStatus": "Estado de salida esperado"
    },
    "request": {
      "title": "Solicitud",
      "subtitle": "Especifica el endpoint de destino, las cabeceras y el estado de retorno esperado",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "Host ej. http://localhost/webhook",
      "endpointTooltip": "URL o IP de tu API. Pasa parámetros y establece tokens de API, etc.",
      "httpMethod": "Método HTTP",
      "httpMethodDefault": "Seleccionar método HTTP",
      "httpMethodTooltip": "Selecciona el método HTTP para este webhook. Por defecto POST",
      "headers": "Cabeceras de solicitud HTTP",
      "headersPlaceholder": "HEADER=custom1,HEADER2=custom2",
      "expectedStatus": "Código de estado HTTP esperado"
    },
    "retry": {
      "title": "Reintentos",
      "subtitle": "Comportamiento de reintento en caso de fallo de solicitud",
      "retryStatus": "Código(s) de estado HTTP para reintentar",
      "retryStatusPlaceholder": "Reintentar en estado ej. 202, 204",
      "retryAttempts": "Máximo de intentos de reintento",
      "retryDelaySeconds": "Retraso de reintento en segundos"
    },
    "payload": {
      "title": "Carga útil",
      "subtitle": "Especifica tu carga útil JSON",
      "data": "Datos (json)",
      "dataPlaceholder": "Datos de solicitud: { \"key\": \"value\" }"
    }
  },
  "actionComponents": {
    "instance": {
      "title": "Instancia",
      "subtitle": "Selecciona la instancia específica que quieres que maneje este filtro de lanzamiento."
    },
    "common": {
      "category": "Categoría",
      "categoryPlaceholder": "ej. categoría",
      "categoryTooltip": "La categoría ya debe existir.",
      "savePath": "Ruta de guardado",
      "savePathPlaceholder": "ej. /ruta/completa/a/carpeta_descarga",
      "numberNoLimit": "Acepta cualquier número (0 es sin límite)",
      "limitsTitle": "Límites",
      "limitsSubtitle": "Configura tus límites de velocidad/ratio/tiempo de siembra",
      "limitDownloadKib": "Limitar velocidad de descarga (KiB/s)",
      "limitUploadKib": "Limitar velocidad de subida (KiB/s)",
      "limitDownloadKb": "Limitar velocidad de descarga (KB/s)",
      "limitUploadKb": "Limitar velocidad de subida (KB/s)",
      "ratioLimit": "Límite de ratio",
      "seedTimeMinutes": "Límite de tiempo de siembra (minutos)",
      "addPaused": "Agregar pausado",
      "addPausedDescription": "Agregar torrent como pausado",
      "skipHashCheck": "Omitir verificación de hash",
      "skipHashCheckDescription": "Agregar torrent y omitir verificación de hash",
      "announceTitle": "Anuncio",
      "announceSubtitle": "Establecer número de reanuncios (si es necesario), eliminar después de Y fallos de anuncio, etc.",
      "disableReannounce": "Deshabilitar reanuncio",
      "disableReannounceDescription": "El reanuncio está habilitado por defecto. Deshabilitar si no es necesario",
      "reannounceInterval": "Intervalo de reanuncio. Ejecutar cada X segundos",
      "reannounceIntervalPlaceholder": "7 es el valor predeterminado y recomendado",
      "deleteStalled": "Eliminar estancados",
      "deleteStalledDescription": "Eliminar torrents estancados después de Y intentos",
      "reannounceMaxAttempts": "Ejecutar reanuncio Y veces"
    },
    "test": {
      "alert": "¡Atención!",
      "text": "La acción de prueba no hace nada excepto mostrar si el filtro funciona. Asegúrate de tener la página de Registros abierta mientras pruebas."
    },
    "exec": {
      "title": "Argumentos de ejecución",
      "subtitle": "Especifica el ejecutable y sus argumentos a ejecutar cuando haya coincidencia de filtro. Usa una ruta absoluta.",
      "path": "Ruta al ejecutable",
      "pathPlaceholder": "Ruta al programa ej. /bin/test",
      "arguments": "Argumentos",
      "argumentsPlaceholder": "Argumentos ej. --test"
    },
    "watchFolder": {
      "title": "Argumentos de carpeta vigilada",
      "subtitle": "Indica dónde autobrr debe guardar los archivos que obtiene. Usa una ruta absoluta.",
      "directory": "Directorio vigilado",
      "directoryPlaceholder": "Directorio vigilado ej. /home/user/rwatch"
    },
    "webhook": {
      "title": "Argumentos de webhook",
      "subtitle": "Especifica la carga útil a enviar al endpoint deseado cuando haya coincidencia de filtro.",
      "endpoint": "Endpoint",
      "endpointPlaceholder": "Host ej. http://localhost/webhook",
      "endpointTooltip": "URL o IP de tu API. Pasa parámetros y establece tokens de API, etc.",
      "payload": "Carga útil (json)",
      "payloadPlaceholder": "Datos de solicitud: { \"key\": \"value\" }"
    },
    "arr": {
      "overrideClientName": "Anular nombre del cliente de descarga para arr",
      "overrideClientNameTooltip": "Anular el nombre del cliente de descarga del configurado en Clientes. Útil si tienes múltiples clientes dentro del arr.",
      "overrideClientId": "Anular ID del cliente de descarga para arr OBSOLETO",
      "overrideClientIdTooltip": "Anular el ID del cliente de descarga del configurado en Clientes. Útil si tienes múltiples clientes dentro del arr."
    },
    "qbittorrent": {
      "macrosTooltip": "El campo puede usar macros para transformar/agregar valores de los metadatos:",
      "tags": "Etiquetas",
      "tagsPlaceholder": "ej. etiqueta1,etiqueta2",
      "savePathPlaceholder": "ej. /ruta/completa/a/carpeta_guardado",
      "savePathTooltip": "Establecer una ruta de guardado personalizada para esta acción. La gestión automática de torrents se encargará de esto si usas qBittorrent con categorías.",
      "downloadPath": "Ruta de descarga",
      "downloadPathPlaceholder": "ej. /ruta/completa/a/carpeta_descarga",
      "downloadPathTooltip": "Establecer una ruta de descarga (incompleta) personalizada para esta acción. La gestión automática de torrents se encargará de esto si usas qBittorrent con categorías.",
      "rulesTitle": "Reglas",
      "rulesSubtitle": "Configura las reglas de tu cliente de torrents",
      "ignoreRules": "Ignorar reglas existentes del cliente",
      "ignoreRulesDescription": "Elegir ignorar las reglas establecidas en la Configuración del Cliente.",
      "contentLayout": "Disposición del contenido",
      "contentLayoutDefault": "Seleccionar disposición de contenido",
      "priority": "Prioridad",
      "priorityDefault": "Deshabilitado",
      "priorityTooltip": "La cola de torrents se habilitará automáticamente si está deshabilitada. Asegúrate de establecer tus límites preferidos en tu cliente.",
      "firstLastPiece": "Descargar primeras y últimas piezas primero",
      "firstLastPieceDescription": "Agregar torrent y descargar primeras y últimas piezas primero"
    },
    "deluge": {
      "label": "Etiqueta",
      "labelPlaceholder": "ej. etiqueta1 (debe existir en Deluge para funcionar)",
      "skipHashCheckTooltip": "Esto solo funcionará en Deluge v2."
    },
    "transmission": {
      "label": "Etiqueta del torrent",
      "labelPlaceholder": "ej. etiqueta1"
    },
    "rtorrent": {
      "label": "Etiqueta",
      "labelPlaceholder": "ej. etiqueta1,etiqueta2",
      "renameToPath": "No agregar nombre del torrent a la ruta",
      "renameDefault": "No"
    },
    "porla": {
      "preset": "Preset",
      "presetPlaceholder": "ej. default",
      "presetTooltip": "Un nombre de preset sensible a mayúsculas configurado en Porla.",
      "savePathPlaceholder": "ej. /ruta/completa/a/datos/torrent"
    }
  },
  "addForm": {
    "title": "Crear filtro",
    "subtitle": "Agregar nuevo filtro.",
    "closePanel": "Cerrar panel",
    "name": "Nombre",
    "required": "Obligatorio",
    "cancel": "Cancelar",
    "create": "Crear",
    "added": "Se agregó el filtro {{name}}"
  }
}
